const STATUS = 'server/STATUS';

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case STATUS:
      return {
        ...state,
        status: action.status,
        message: action.message
      };
    default:
      return state;
  }
}


export function setStatus(status, message) {
  return {
    type: STATUS,
    status,
    message
  }
}



// WEBPACK FOOTER //
// ./redux/server.js